import React, { useCallback, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useEffect } from "react";
import moment from "moment";

export default function SpacePlaningRequest(props) {
  const { open, handleClose, handleRequestPlaning } = props;
  const [value, SetValue] = useState(new Date());

  const [submitDisable, setSubmitDisable] = useState(true);
  useEffect(() => {
    if (value) {
      setSubmitDisable(false);
    } else {
      setSubmitDisable(true);
    }
  }, [value]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
            Request Space Planning
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            <DesktopDatePicker
              inputFormat="yyyy-MM-dd"
              label="Select Date"
              value={value}
              onChange={(date) => SetValue(date)}
              fullWidth
              renderInput={(params) => (
                <TextField {...params} fullWidth />
              )}
              sx={{ width: '100%'}}
            />
          </Box>
          <Button
            type="button"
            variant="contained"
            color="warning"
            size="large"
            disabled={submitDisable}
            onClick={() =>
              handleRequestPlaning(value)
            }
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
